import _debug from 'debug'

export const debug = _debug('app')
export default debug
